/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, { attr } from '@warp-drive/legacy/model';
import { computed } from '@ember/object';
import type { Type } from '@warp-drive/core/types/symbols';
import { findBy } from '@linc-technologies/linced-common/utils/arrays';
import LocationType from '@linc-technologies/linced-common/enums/location-type';
import NSWSource from '@linc-technologies/linced-common/enums/nsw-source';
import NSWStatus from '@linc-technologies/linced-common/enums/nsw-status';
import SIFYesOrNo from '@linc-technologies/linced-common/enums/sif-yes-or-no';

// Proto: schools.Location.
export default class Location extends Model {
  declare [Type]: 'schools/location';

  @attr('string', { defaultValue: '' })
  declare externalId: string;

  @attr('string', { defaultValue: '' })
  declare schoolId: string;

  @attr('string', { defaultValue: '' })
  declare name: string;

  @attr('string', { defaultValue: '' })
  declare description: string;

  @attr('number', { defaultValue: 0 })
  declare size: number;

  @attr('number', { defaultValue: 0 })
  declare capacity: number;

  @attr('number', { defaultValue: 0 })
  declare type: number;

  @attr('number', { defaultValue: 0 })
  declare status: number;

  @attr('number', { defaultValue: 0 })
  declare source: number;

  @attr('number', { defaultValue: 0 })
  declare canBeTimetabled: number;

  @computed('type')
  get displayType() {
    return findBy(LocationType.values, 'value', this.type)?.label ?? '';
  }

  @computed('status')
  get displayStatus() {
    return findBy(NSWStatus.values, 'value', this.status)?.label ?? '';
  }

  @computed('source')
  get displaySource() {
    return findBy(NSWSource.values, 'value', this.source)?.label ?? '';
  }

  @computed('canBeTimetabled')
  get displayCanBeTimetabled() {
    return findBy(SIFYesOrNo.values, 'value', this.canBeTimetabled)!.label;
  }
}
